<template>
    <!-- display customer account -->
    <div class="container-fluid">
        <div class="row my-3">
            <div class="col-sm-4 col-9">
                <h4>Settings</h4>
            </div>
            <div class="col-sm-8 col-3 text-right">
                <router-link :to="{ name: 'customer-account' }" class="btn btn-outline-dark btn-sm">
                    <i class="fas fa-user-circle"></i> 
                    <span class="d-none d-sm-inline"> 
                        <span v-if="user && user.firstName" class="add-ellipsis"> {{user.firstName | capitalize}}!</span> 
                        <span v-else>Account</span>
                    </span>
                </router-link>
            </div>
        </div>

        <div v-if="showSettingsMenu" class="row">
            <div class="col-12">
                <p>
                    <span @click="showChangePasswordFxn" class="clickable">
                        <i class="fas fa-angle-double-right fa-xs"></i> Change Password
                    </span>
                </p>
                <p>
                    <router-link :to="{ name: 'home' }">
                        <i class="fas fa-angle-double-right fa-xs"></i> Contact Support
                    </router-link>
                </p>
                <p>
                    <router-link :to="{ name: 'home' }">
                        <i class="fas fa-angle-double-right fa-xs"></i> About aNewItem
                    </router-link>
                </p>
            </div>
        </div>

        <div v-if="showChangePassword" class="row">
            <!-- <div class="col-lg-4 col-md-6 col-sm-8 col-12"> -->
            <div class="col-12">
                <div class="card">
                    <div class="card-header bg-dark">
                        <h5 class="font-weight-bold text-white">Change Password</h5>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-4 col-md-6 col-sm-8 col-12">
                                <!-- display alert message desktop view -->
                                <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-3 p-1`" role="alert">
                                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                                </div>
                                <div class="mt-3">
                                    <span class="font-weight-bold">Old Password</span>
                                    <div class="input-group">
                                        <input v-model="oldPassword" :type="showOldPassword ? `text` : `password`" ref="oldPassword" class="form-control no-lines">
                                        <div class="input-group-append">
                                            <div @click.prevent="showOldPasswordFxn" class="input-group-text bg-light font-weight-bold clickable">
                                                <i v-if="showOldPassword" class="fas fa-eye-slash"></i>
                                                <i v-else class="fas fa-eye"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <span class="font-weight-bold">New Password</span>
                                    <div class="input-group">
                                        <input v-model="password" :type="showNewPassword ? `text` : `password`" ref="password" class="form-control no-lines">
                                        <div class="input-group-append">
                                            <div @click.prevent="showNewPasswordFxn" class="input-group-text bg-light font-weight-bold clickable">
                                                <i v-if="showNewPassword" class="fas fa-eye-slash"></i>
                                                <i v-else class="fas fa-eye"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <span class="font-weight-bold">Repeat Password</span>
                                    <div class="input-group">
                                        <input v-model="rePassword" :type="showRePassword ? `text` : `password`" class="form-control no-lines">
                                        <div class="input-group-append">
                                            <div @click.prevent="showRePasswordFxn" class="input-group-text bg-light font-weight-bold clickable">
                                                <i v-if="showRePassword" class="fas fa-eye-slash"></i>
                                                <i v-else class="fas fa-eye"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center mt-3">
                                    <div class="clearfix">
                                        <button @click.prevent="userResetPassword" class="loadn btn btn-dark-green float-left">Update Password</button>
                                        <button @click.prevent="showSettingsMenuFxn" class="loadn btn btn-outline-danger float-right">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { webpageTitle } from '@/store/dry'

import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: "CustomerSettings",
    data() {
        return {
            showSettingsMenu: true,
            showChangePassword: false,
            oldPassword: '',
            password: '',
            rePassword: '',
            showOldPassword: false,
            showNewPassword: false,
            showRePassword: false,
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        showOldPasswordFxn() {
            this.showOldPassword = !this.showOldPassword
        },
        showNewPasswordFxn() {
            this.showNewPassword = !this.showNewPassword
        },
        showRePasswordFxn() {
            this.showRePassword = !this.showRePassword
        },
        showSettingsMenuFxn() {
            this.showChangePassword = false
            this.showSettingsMenu = true
        },
        showChangePasswordFxn() {
            this.showSettingsMenu = false
            this.showChangePassword = true
        },
    },
    computed: {
        ...mapGetters(['user'])
    },
    created() {
        webpageTitle(`Account settings`)
        this.$emit('update:layout', LayoutGeneral);
    }
}
</script>